export default {
  notifications: [],
  unread: 0,
}
